import { XIF } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';


export const derivatAutoCreateVirtel_modulrogalj_priprema_ulaza = (vrstaprofila) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input = {
    vrstaprofila: vrstaprofila
  };
  return pods_input;
};

export const derivatAutoCreateVirtel_modulrogalj = (pods_input) => {
  // TODO izbaiciti duplikat iz funkcije derivatProfil da nemamo dva puta racunanje istog derivata
  // derivat local 1 - SAMO ROGALJ
  // Rogalj prebacen iz derivata rogalj po uzoru na Excel fajl konstrukcija Kladovo.
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  // promenljive iz excela
  const C6 = pods_input.vrstaprofila; // mora da primi vrsta profila (od komore)


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  x = {
    ...pods_input,
    terkategorija: 'M',
    kolicina: 8, // Broj komada rogljeva je uvek 8 po jednom komadu modula
    jm: tclocal.JM_KOM,
    virtelschemakey: 'terkk$modul$rogalj',
    _draftelschemakey: 'terkk$modul$rogalj',
    virtelclass: "terkk$modul$rogalj",
    terkknivo: 'CHILDOFMODUL',
  };
  x.calculated_ident = XIF(C6 === "STD-50", "A030000000000011", XIF(C6 === "STD-70", "A030010000000014", XIF(C6 === "TB-50", "A030000000000026", XIF(C6 === "TB-70", "A030000000000025", XIF(C6 === "STD-BELA-50", "A030000000000011", XIF(C6 === "STD-BELA-70", "A030010000000014", XIF(C6 === "TB-BELA-50", "A030000000000026", XIF(C6 === "TB-BELA-70", "A030000000000025", XIF(C6 === "TB-PLAVA-70", "A030000000000025", XIF(C6 === "TB-ZELENA-70", "A030000000000025", null))))))))));
  // Naziv za rogalj
  x.naziv = XIF(C6 === "STD-50", "ROGALJ PVC N 50/45 T PRO-LAM", XIF(C6 === "STD-70", "ROGALJ ALUMINIJUM PROFIL A 70/50 PRO-LAM", XIF(C6 === "TB-50", "ROGALJ PVC AFGTT50-45 50mm", XIF(C6 === "TB-70", "ROGALJ PVC ASFG70-500 70mm", XIF(C6 === "STD-BELA-50", "ROGALJ PVC N 50/45 T PRO-LAM", XIF(C6 === "STD-BELA-70", "ROGALJ ALUMINIJUM PROFIL A 70/50 PRO-LAM", XIF(C6 === "TB-BELA-50", "ROGALJ PVC AFGTT50-45 50mm", XIF(C6 === "TB-BELA-70", "ROGALJ PVC ASFG70-500 70mm", XIF(C6 === "TB-PLAVA-70", "ROGALJ PVC ASFG70-500 70mm", XIF(C6 === "TB-ZELENA-70", "ROGALJ PVC ASFG70-500 70mm",))))))))));
  //
  x = {
    ...x,
    ..._getParamsFromLib("terkk$modul$rogalj")
  }; // parametri na kraju imaju prioritet
  z['rogalj'] = x; // univerzalno i moze se spajati sa arrayima od drugih derivata iz ove biblioteke
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  console.log(z);

  
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};

